<template>
  <div class="page-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden v-else-if="!getHasProgramRegistered" routerPath="incorrectRole" />
    <div v-else class="page-container vector-background col center">
      <MessagePage :img="img" :title="title" :msg="msg" :msg2="msg2" :goto="goto" />
    </div>
  </div>
</template>

<script>
import Forbidden from "@/views/Forbidden.vue";
import MessagePage from "@/components/ErrorPage.vue";
import { mapGetters } from "vuex";
import moment from "moment/moment";
import User from "@/services/User";
import store from "@/store";

export default {
  name: "PengumumanPage",
  components: {
    MessagePage,
    Forbidden
  },
  data() {
    return {
      img: require("@/assets/img/registration-success.png"),
      title: "Selamat Proses Daftar Berhasil!",
      isPrimary: true,
      isDanger: false,
      msg: "Mohon menunggu proses seleksi.",
      msg2:
        "Pengumuman proses seleksi akan diumumkan dalam " +
        store.getters.getPeriodEnd("registration") +
        " hari ke depan.",
      goto: []
    };
  },
  computed: {
    ...mapGetters({
      getRegistrationPeriodOpened: "getRegistrationPeriodOpened",
      getPeriodEnd: "getPeriodEnd",
      getUserRole: "getUserRole",
      getAccessToken: "getAccessToken",
      getTermName: "getTermName",
      getHasProgramRegistered: "getHasProgramRegistered"
    })
  },
  created() {
    if (
      this.getUserRole[this.getUserRole.length - 1].role_id != 0 &&
      this.getHasProgramRegistered
    ) {
      const announcementTime = moment(
        store.getters.getPeriodEnd("registration")
      );
      announcementTime.locale("id");
      this.msg2 =
        "Pengumuman proses seleksi akan diumumkan pada " +
        announcementTime.format("DD MMMM YYYY");
      User.getRegistrationData(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: inherit;
}
</style>
